

























import { computed, defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import config from "@/config";
import BaseSpinner from "@/components/BaseSpinner";
import GuestNavigationBar from "@/components/GuestNavigationBar";
import MainNavigationBar from "@/components/MainNavigationBar";
import MainStickyHeader from "@/components/MainStickyHeader";

export default defineComponent({
  name: "MainNavigationView",
  components: { GuestNavigationBar, MainStickyHeader, BaseSpinner, MainNavigationBar },
  props: {
    isChangedFeatures: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const { authUser, allowAccess } = useAuthUser();

    const showPoweredBy = computed(() => !config.featureHideScrileLink);
    const showMenu = computed(() => allowAccess.value && !props.loading);
    const isLoginRoute = computed(() => root.$route?.meta?.login);
    const showGuestMenu = computed(
      () => !authUser.value && !isLoginRoute.value && !root.$route?.name?.includes("participantConsentLink")
    );

    return {
      showGuestMenu,
      showMenu,
      showPoweredBy,
      isLoginRoute,
    };
  },
});
